import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AUTH_ROUTE } from "@/shared/lib/routes";
import * as Sentry from "@sentry/react";
import {
  consumeSsoReturn,
  syncAnalyticsIdentity,
} from "@/shared/lib/analytics";

const Authed = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_authed")({
  component: Authed,
  beforeLoad: ({ context, preload }) => {
    if (!context.me) throw redirect({ to: AUTH_ROUTE });

    Sentry.setUser({ id: context.me.id });
    syncAnalyticsIdentity(context.me);
    // Not on a preload, which only means a hover: the SSO return is a real load.
    if (!preload) consumeSsoReturn(context.me);
    if (context.me.companies?.[0]) {
      Sentry.setContext("company", {
        id: context.me.companies[0].id,
        slug: context.me.companies[0].slug,
      });
    }
  },
});
